import React from 'react';
import './App.css';
import { QuizProvider } from './context/QuizContext';
import MainLayout from './components/MainLayout';
import { Toaster } from './components/ui/toaster';

function App() {
  return (
    <QuizProvider>
      <MainLayout />
      <Toaster />
    </QuizProvider>
  );
}

export default App;
